// ── Razorpay Checkout helper (client) ───────────────────────────────────────────
// Loads the checkout script once, opens the hosted checkout for a server-created order,
// and resolves with the handler payload (payment id + signature) for server verification.

let scriptPromise = null;
export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    const s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
  return scriptPromise;
}

// order: { orderId, amount, currency, keyId } from createRazorpayOrder.
// Resolves { razorpayPaymentId, signature } on success; rejects on dismiss/failure.
export function openRazorpayCheckout(order, { name = 'Ledxo Hub', description = '', prefill = {} } = {}) {
  return new Promise(async (resolve, reject) => {
    const ok = await loadRazorpay();
    if (!ok || !window.Razorpay) return reject(new Error('Could not load Razorpay checkout'));
    const rzp = new window.Razorpay({
      key: order.keyId,
      order_id: order.orderId,
      amount: order.amount,
      currency: order.currency,
      name,
      description,
      prefill,
      theme: { color: '#1a73e8' },
      handler: (resp) => resolve({
        razorpayPaymentId: resp.razorpay_payment_id,
        signature: resp.razorpay_signature,
        razorpayOrderId: resp.razorpay_order_id,
      }),
      modal: { ondismiss: () => reject(new Error('Payment cancelled')) },
    });
    rzp.on('payment.failed', (resp) => reject(new Error(resp?.error?.description || 'Payment failed')));
    rzp.open();
  });
}
